import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const SwitchRowWrapper = styled.div`
  width: 100%;
  padding: ${Spacing.S16} 0 ${Spacing.S16} 0;
`
